import { getUser } from '@/services/userService';
import { useQuery } from '@tanstack/react-query';

export const useGetUserQuery = () => {
	return useQuery({
		queryKey: ['user'],
		queryFn: getUser
	});
};
